/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Diet_DetailInputs */

const en_portal_week_diet_detail = /** @type {(inputs: Portal_Week_Diet_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training day`)
};

const pl_portal_week_diet_detail = /** @type {(inputs: Portal_Week_Diet_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień treningowy`)
};

/**
* | output |
* | --- |
* | "Training day" |
*
* @param {Portal_Week_Diet_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_diet_detail = /** @type {((inputs?: Portal_Week_Diet_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Diet_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_diet_detail(inputs)
	return en_portal_week_diet_detail(inputs)
});